function adjustModel(model) {
  if (!model || !model.data || model.data.isDemo) {
    return;
  }

  if (!model.data.bones) {
    model.data.bones = [];
  }
  if (model.data.bones.length === 0) {
    model.data.bones.push({
      name: "Maxilla",
      filename: "maxilla.stl",
      isBone: true,
    });
    model.data.bones.push({
      name: "Mandibula",
      filename: "mandibula.stl",
      isBone: true,
    });
  }

  if (!model.data.nerves) {
    model.data.nerves = [];
  }
  if (model.data.nerves.length === 0) {
    model.data.nerves.push({
      name: "Nerve",
      filename: "merged_canals.stl",
      isNerve: true,
    });
  }

  if (model.data.nerves.length === 1) {
    model.data.nerves.push({
      name: "Left Nerve",
      filename: "left_segment.stl",
      isNerve: true,
      isSingle: true,
      isVisible: false,
      isLeft: true,
      opacity: 0,
      // color: "transparent"
    });

    model.data.nerves.push({
      name: "Right Nerve",
      filename: "right_segment.stl",
      isNerve: true,
      isSingle: true,
      isVisible: false,
      isLeft: false,
      opacity: 0,
      // color: "transparent"
    });
  }

  if (!model.data.gingivae || model.data.gingivae.length === 0) {
    if (!model.data.gingivae) {
      model.data.gingivae = [];
    }
    model.data.gingivae.push({
      name: "Lower Gingiva",
      filename: "lower.gingiva.stl",
      isUpper: false,
      isGingiva: true,
    });
    model.data.gingivae.push({
      name: "Upper Gingiva",
      filename: "upper.gingiva.stl",
      isUpper: true,
      isGingiva: true,
    });
  }
  // model.data.gingivae = [];

  if (!model.data.airways || model.data.airways.length === 0) {
    if (!model.data.airways) {
      model.data.airways = [];
    }
    model.data.airways.push({
      name: "Airway",
      filename: "airways.stl",
    });
  }

  if (!model.data.dentations) {
    model.data.dentations = [];
  }
  if (!model.data.dentations.find((d) => d.name == "Maxilla")) {
    model.data.dentations.push({
      name: "Maxilla",
      groups: [],
    });
  }
  if (!model.data.dentations.find((d) => d.name == "Mandible")) {
    model.data.dentations.push({
      name: "Mandible",
      groups: [],
    });
  }
  if (!model.data.dentations.find((d) => d.name == "Other")) {
    model.data.dentations.push({
      name: "Other",
      groups: [],
    });
  }

  model.data.dentations.forEach((dentation) => {
    if (dentation.name === "Maxilla" && dentation.groups.length === 0) {
      addDentationGroup(dentation, 11, 19);
      addDentationGroup(dentation, 21, 29);
    }
    if (dentation.name === "Mandible" && dentation.groups.length === 0) {
      addDentationGroup(dentation, 31, 39);
      addDentationGroup(dentation, 41, 49);
    }
    if (dentation.name === "Other" && dentation.groups.length === 0) {
      dentation.groups.push({ name: `other`, teeth: [] });
    }
  });
}

function addDentationGroup(dentation, min, max) {
  let group = { name: `${min}-${max}`, teeth: [] };
  // for (let i = min; i <= max; i++) {
  //   group.teeth.push({
  //     name: `${i}`,
  //     filename: `tooth_${i}.stl`,
  //   });
  // }
  dentation.groups.push(group);
}

function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

function updateToothDentition(tooth, updateVisible) {
  if (tooth) {
    let isMaxilla = getIsMaxillaTooth(tooth);
    if (tooth.isMaxilla != isMaxilla) {
      tooth.isMaxilla = tooth.isUpper = isMaxilla;
      let dentitionName = tooth.isMaxilla ? "Maxilla" : "Mandible";
      tooth.dentition = dentitionName;
      if (updateVisible) {
        var dentation = vueApp.dentations.find((x) => x.name === dentitionName);
        if (dentation) {
          if (tooth.dentition == dentitionName && viewer) {
            tooth.isVisible = dentation.isVisible;
            itemVisibilityChanged(tooth, tooth.color, vueApp.teethOpacity);
          }
        }
      }
    }
  }
}

function getToothFileName(tooth) {
  let toothNumber = tooth.savedNumber ? tooth.savedNumber : tooth.number;
  if (!toothNumber) return tooth.filename;

  let fileName = `tooth_${toothNumber}`;

  let prevTag = tooth.prevTag;
  if (prevTag && prevTag.length > 0) {
    fileName += `-${prevTag}`;
  }
  let addedTag = tooth.addedTag;
  if (addedTag && addedTag.length > 0) {
    fileName += `-${addedTag}`;
  }
  let numberType = tooth.numberType;
  if (numberType && numberType != "primary" && numberType.length > 0) {
    fileName += `-${numberType}`;
  }
  let remarks = tooth.remarks;
  if (remarks && remarks.length > 0) {
    fileName += `-${remarks}`;
  }
  fileName += ".stl";
  return fileName;
}

function getToothNewFileName(tooth) {
  let toothNumber = tooth.newNumber
    ? tooth.newNumber
    : tooth.savedNumber
    ? tooth.savedNumber
    : tooth.number;

  let newFileName = `tooth_${toothNumber}`;

  let newPrevTag = tooth.newPrevTag ? tooth.newPrevTag : tooth.prevTag;
  if (newPrevTag && newPrevTag.length > 0) {
    newFileName += `-${newPrevTag}`;
  }
  let newAddedTag = tooth.newAddedTag ? tooth.newAddedTag : tooth.addedTag;
  if (newAddedTag && newAddedTag.length > 0) {
    newFileName += `-${newAddedTag}`;
  }
  let newNumberType = tooth.newNumberType
    ? tooth.newNumberType
    : tooth.numberType;
  if (newNumberType && newNumberType != "primary" && newNumberType.length > 0) {
    newFileName += `-${newNumberType}`;
  }
  let newRemarks = tooth.newRemarks ? tooth.newRemarks : tooth.remarks;
  if (newRemarks && newRemarks.length > 0) {
    newFileName += `-${newRemarks}`;
  }
  newFileName += ".stl";
  return newFileName;
}

function getIsMaxillaTooth(tooth) {
  let currentNumber = 0;
  if (tooth.newNumber) {
    currentNumber = tooth.newNumber;
  } else if (tooth.savedNumber) {
    currentNumber = tooth.savedNumber;
  } else if (tooth.number) {
    currentNumber = tooth.number;
  } else {
    currentNumber = +tooth.name;
  }
  if (!currentNumber || currentNumber < 0) {
    return null;
  }

  let numberString = currentNumber.toString();
  let isMandible =
    numberString.startsWith("3") ||
    numberString.startsWith("4") ||
    numberString.startsWith("7") ||
    numberString.startsWith("8");
  let isMaxilla =
    numberString.startsWith("1") ||
    numberString.startsWith("2") ||
    numberString.startsWith("5") ||
    numberString.startsWith("6");
  return !isMandible;
}

export {
  adjustModel,
  getIsMaxillaTooth,
  updateToothDentition,
  getToothNewFileName,
  getToothFileName,
};
